module.exports = __webpack_public_path__ + "img/astral_3.ec4bb1f1.svg";